/** SessionStorage key: JSON `{ "message": string }` consumed once after magic-link auth. */
export const UI_AGENT_MAGIC_LINK_KICKOFF_KEY = 'ui_agent_magic_link_kickoff'

/** Synthetic user message so the agent replies with a welcome / orientation. */
export const MAGIC_LINK_AGENT_KICKOFF_MESSAGE =
  'I just signed in after applying through the jobs board. Please welcome me and briefly explain what I can do here.'
